import authStore from "../stores/authStore";
import { Link } from "react-router-dom";

export default function Footer() {
    return (
    <div class="footer">
        <p>Copyright © 2026 Scoped</p>  
        <p>•</p>
        <p><Link to="/about">About Scoped</Link></p>
    </div>  
    )
}